export default __webpack_public_path__ + "static/media/cluster.63e339cc.svg";